import { createElement } from 'react';

import { ReadableViewportHelper } from '../../ChartViewport';
import {
  copyOrgChartPngToClipboard,
  exportOrgChartPdf,
  exportOrgChartPng,
} from '../../exports/exportOrgChart';
import { ICON_FOR_SHAPE } from '../../TaxDiagram/components/TaxChartLegend';
import {
  copyTaxChartPngToClipboard,
  exportTaxChartPdf,
  exportTaxChartPng,
} from '../../TaxDiagram/exportTaxChart';
import { LEGEND_ROWS } from '../../TaxDiagram/tax-chart-shapes';
import {
  StructureEntityNode,
  TaxStructureEntityNode,
  TaxStructureProvider,
} from '../components';
import { LayoutGeometryHelper as G } from '../layout';
import type {
  StructureChartAdapter,
  StructureChartKind,
} from './structure-chart-adapter.types';
import { TaxNodeFrameHelper } from './tax-node-frame-helper';

class StructureChartAdapterHelper {
  static readonly ORG: StructureChartAdapter = {
    minZoom: ReadableViewportHelper.ORG_MIN_ZOOM,
    getFrame: () => G.CARD_FRAME,
    NodeComponent: StructureEntityNode,
    legendSection: null,
    Provider: null,
    exportPng: exportOrgChartPng,
    exportPdf: exportOrgChartPdf,
    copyPng: copyOrgChartPngToClipboard,
  };

  static readonly TAX: StructureChartAdapter = {
    minZoom: ReadableViewportHelper.TAX_MIN_ZOOM,
    getFrame: (structure) => TaxNodeFrameHelper.create(structure),
    NodeComponent: TaxStructureEntityNode,
    legendSection: {
      title: 'Shapes',
      rows: LEGEND_ROWS.map(({ shape, label }) => ({
        label,
        sample: createElement(ICON_FOR_SHAPE[shape]),
      })),
    },
    Provider: TaxStructureProvider,
    exportPng: exportTaxChartPng,
    exportPdf: exportTaxChartPdf,
    copyPng: copyTaxChartPngToClipboard,
  };

  static forKind(kind: StructureChartKind): StructureChartAdapter {
    return kind === 'tax'
      ? StructureChartAdapterHelper.TAX
      : StructureChartAdapterHelper.ORG;
  }
}

export { StructureChartAdapterHelper };
